import { render } from "./TotalPriceAr.vue?vue&type=template&id=70f5399e&scoped=true"
import script from "./TotalPriceAr.vue?vue&type=script&lang=js"
export * from "./TotalPriceAr.vue?vue&type=script&lang=js"

import "./TotalPriceAr.vue?vue&type=style&index=0&id=70f5399e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f5399e"]])

export default __exports__